import { collection } from "firebase/firestore";
import { db } from "./FirebaseConfig";

export const vendorCollection = collection(db, "vendors_test");
export const usersCollection = collection(db, "users");
export const ordersCollections = collection(db, "orders");
